if (!customElements.get('show-more-less')) {
  class ShowMoreLess extends HTMLElement {
    constructor() {
      super()

      this.$content = this.querySelector('[data-show-more-less-content]')
      this.$button = this.querySelector('[data-show-more-less-button]')
      this.three_line_height = parseFloat((window.getComputedStyle(this.$content).lineHeight).replace('px')) * 3

      if (this.$button) this.$button.addEventListener('click', this.toggleSeeMoreLess.bind(this))

      this.checkQuoteOverflow()

      if (!this.$content) return
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            this.checkQuoteOverflow()
          }
        }
      })
      resizeObserver.observe(this.$content)
    }

    toggleSeeMoreLess() {
      if (!this.$content || !this.$button) return
      this.$content.classList.toggle('!line-clamp-none')
      this.$content.classList.toggle('[&_p]:!my-0')
      this.$button.textContent = this.$content.classList.contains('!line-clamp-none') ? 'See less' : 'See more'
    }

    checkQuoteOverflow() {
      if (!this.$content || !this.$button) return
      if (!this.$content.classList.contains('line-clamp-none') && this.$content.scrollHeight <= this.three_line_height)
        return this.$button.classList.add('hidden')
      if (this.$content.classList.contains('line-clamp-none') && this.$content.clientHeight >= this.$content.scrollHeight)
        return this.$button.classList.add('hidden');
      this.$button.classList.remove('hidden');
    }
  }

  customElements.define('show-more-less', ShowMoreLess)
}
